export default __webpack_public_path__ + "static/media/cdm.720fd0ac.jpg";